import { Editor, TinyMCE } from "tinymce";
import { makeEditorModal } from "../Modal";
import { FeatureClass } from "../core/FeatureClass";
import { displayErrors, getData, getPoints, initEditor, insertToEditor, pointsValid, setWindowNode, toJsonHtml, waitFor } from "../core/Utils";
import { inputTransformation } from "../save/Interface";
import { getModalInputId, insertData } from "../save/SaveUtils";
import { ajaxSpin } from "../../Utils/utils";

declare let tinymce:TinyMCE

export function addFreetext(editor:Editor){
    const config = {
        featureName: "freetext",
        editor: editor,
        id: "ft",
        icon: "freitext",
        tooltip: 'Freitexteingabe',
        menuItems: [{
            name: 'edit-ft',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                data.text = node.innerHTML;
                openModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            openModal(editor, command, {points:0, text: ''});
        },
        commandAction: (data:freeTextData) => {
            insertFreetext(data);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

interface freeTextData {
    points: number;
    type: string;
    text: string;
    identifier?: string | '';
    id: number;
}

export function transformFt(data:freeTextData, ind:number, obj:HTMLElement):inputTransformation {
    const html = '<div class="form-group">'+
    '<textarea data-type="' + data.type + '" data-id="' + data.id + '" class="form-control ft_antwort input" rows="3" placeholder="Antwort eingeben" name="' + data.id + '_' + ind + '"></textarea>' +
    '</div>';
    // let text = $(obj).html(); // eig unnötig, aber kann man wohl noch brauchen
    return {
        solution: {
            type: data.type,
            correct: $(obj).html(),
            points: parseFloat(data.points.toString().replace(",", ".")),
            identifier: data.identifier,
            id: data.id,
        },
        html: html
    }
}


function openModal(editor:Editor, command:string, data:freeTextData){
    const content = '<div class="freetext-info">' +
    '<p>Hier kannst du eine Freitexteingabe erstellen. Der/die Schüler/-in bewertet die Eingabe nach Abgabe des ABs selbst.</p>' +
    '</div>';
    const modalId = 'create-freetext'
    const settings = {
        leftInput: {
            placeholder: "Punkte",
            text: "Punkte",
            type: "text",
            value: data.points,
        },
        submitBtn: {
            text: 'Einfügen',
            class: 'add-freetext',
        },
        size: 'xl',
        centered: true,
        faq: 18,
        id: data.id,
    }

    const onclick = function(modal:JQuery<HTMLElement>){

        const data = getFreetextData(modal);
        if (data){
            return insertData(data, editor, command, modalId)
        // saveAndInsertFreetext(textEditor, command, data, $(".add-freetext"));
        return true;
        }
    }
    
    const modal = makeEditorModal(modalId, 'Freitexteingabe erstellen', content, settings, onclick);
    $("#freetext").focus();
    
    if (tinymce.get("freetext-input") == undefined){
        
        $("#create-freetext").find(".modal-body").after('<div class="px-2 pb-2"><textarea id="freetext-input"></textarea></div>') 
        // tinymce.init(initEditor("#freetext-input", data.text))
        waitFor(checkIfAreaExists, initFreetextEditor, data.text);
    } else {
        
        const textEditor = tinymce.get("freetext-input");
        textEditor.setContent(data.text);
        // textEditor.show();
    }
}


function initFreetextEditor(text:string){
    tinymce.init(initEditor("#freetext-input", text))
}

function checkIfAreaExists(){
    return document.getElementById("freetext-input") != null;
}

function getFreetextData(modal:JQuery<HTMLElement>){
    const textEditor = tinymce.get("freetext-input");
    const text = textEditor.getContent();
    const points = getPoints(modal)
    const id = getModalInputId(modal);

    const errors = [];
    if (text == '' || text == '<p></p>'){
        errors.push("Die Musterlösung darf nicht leer sein");
    }
    if (!pointsValid(points)){
        errors.push("Du musst eine Punktzahl festlegen");
    }

    
    if (errors.length == 0){
        return {
            points: points,
            text: text,
            identifier: 0, // TODO: CHANGE
            id: id,
        }
    } else {
        displayErrors(errors);
        return false;
    }
}



function insertFreetext(data:freeTextData){

    const jsonData = {
        points: data.points,
        identifier: data.identifier,
        type: "ft",
        id: data.id,
    }
   // tinymce.get("freetext").setContent('');
    saveForOldVersion(data.text, jsonData)

}


function saveForOldVersion(text:string, jsonData){
    const config = {
        url: '/freetext/create',
        data: {
        //    action: "save_freitext_aufgabe",
            answer: text,
            taskId: $("#aufgabe-id").val(),
        },
        success: function(data){
                
            jsonData.identifier = data.id;
            jsonData.text = text;

            const html = transformFreetextForInsert(jsonData)

            insertToEditor(html);

        }
    }
    ajaxSpin(config, $(".add-freetext"));
}

export function transformFreetextForInsert(data:freeTextData):string{
    const displayText = data.text;
    data.text = escapeJsonSigns(data.text);
    delete data.text;
    const json = toJsonHtml(data);

    const html = '<div id="ft" data-json="' + json +'" class="mceNonEditable form-control input-item" style="min-height: 80px;">' + displayText + '</div>';

    return html;
}

export function escapeJsonSigns(text:string):string{
    const replaceOne = '|+|';
    const replaceTwo = '|-|';

    text = text.replaceAll("'", replaceOne)
    text = text.replaceAll('"', replaceTwo);
    text = text.replaceAll('>', '»')
    text = text.replaceAll('<', '«')

    return text;
}
